// extracted by mini-css-extract-plugin
export var audioPlayer = "_pg-0";